module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KA3PQH/tc-custom/FC-9781528950541.jpg?1684515191996?1719576272029",
      "alt": "This image is the cover for the book Finish-in-Four"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Finish-in-Four\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Higher education is in a state of crisis!")]), _c('p', [_vm._v("College budgets are becoming a challenge to balance. Expenses are continually increasing in an environment of declining enrollments, endowments, and government support. The stop-gap solution for decades was to increase tuition—this is no longer viable.")]), _c('p', [_vm._v("Students, parents, donors, and government agencies are scrutinizing the cost and return on investment of a college education. Colleges are under pressure for their underperformance of only graduating 40% of students on time while the national student debt is skyrocketing.")]), _c('p', [_vm._v("Addressing the issue of approximately 2 million students that start college annually and drop out provides colleges with an opportunity to turn the crisis around. Finish in Four introduces a model that provides an approach for developing strategic solutions in ten key areas to improve on-time graduation rates and reduce student debt. This will result in improved fiscal stability for America’s struggling colleges.")]), _c('p', [_vm._v("A must read for all college stakeholders and students selecting a college.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jeff Marsee, Ph.D.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0mm",
      "margin-bottom": ".0001pt",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Jeff Marsee, Ph.D., is a higher education consultant, trainer, presenter, former college president and Fulbright Scholar. His extensive career has included working with and at non-profit and for-profit (two and four-year) colleges; focusing on changing institutional models to improving student retention and graduation rates. The cumulation of his experiences, observations and research has been the development of a strategic planning (C-PAM) model that helps colleges assess and improve their performance in ten critical student success areas.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0